export default __webpack_public_path__ + "static/media/NHFSD.53ed0247.jpg";